<div class="accordion" id="accordionPanelsStayOpenExample" [ngClass]="maximized? 'FullScren': '' ">
  <div class="accordion-item rounded-corner shadow-b overflow-hidden">
    <h2 class="accordion-header accordion-button text-primary p-2 box-shadow-0" id="panelsStayOpen-headingOne"
      style="padding-right: 0px !important;">
      <div style="width:70%;">
        <i class="fal fa-file-alt icon-header"></i>
        <b class="font-md">{{eventHistoryLabel}} </b>
        <span class="px-1"> - </span><span class="font-md"> {{ AgentLanId }}</span>
      </div>
      <div style="width:30%;display:flex;justify-content: flex-end;">
        <button type="button" class="btn" (click)=toggleFilter() style="padding: 8px;">
          <i class="" aria-hidden="true" data-bs-toggle="tooltip" data-bs-placement="top"
            [ngClass]="filteredEvents.length === 0 ? 'fal fa-cog' : 'fas fa-cog fa-spin'"
            title="{{filterByEventsLabel}}"></i>
        </button>

        <button type="button" class="btn" (click)=toggleMaximize() data-bs-toggle="tooltip" data-bs-placement="top"
          style="padding: 8px;">
          <i aria-hidden="true" title="{{minimizeLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
            [ngClass]="maximized? 'fal fa-compress-wide': '' "></i>
          <i aria-hidden="true" title="{{maximizeLabel}}" data-bs-toggle="tooltip" data-bs-placement="top"
            [ngClass]="maximized? '': 'fal fa-expand' "></i>
        </button>
        <button type="button" class="btn" (click)="toggleCollapse()" style="padding: 8px;">
          <i class="fal fa-chevron-down" *ngIf="collapsed"></i>
          <i class="fal fa-chevron-up" *ngIf="!collapsed"></i>
        </button>
      </div>
    </h2>
    <div id="panelsStayOpen-collapseOne"
      [ngClass]="collapsed? 'accordion-collapse collapse hide': 'accordion-collapse collapse show'"
      aria-labelledby="panelsStayOpen-headingOne">
      <div id="___normalEvents" class="accordion-body text-center px-2 py-0 overflow-auto custom-area"
        style="height: inherit;">
        <div class="container custom-area" #scrollViolations>
          <ng-container *ngIf="events.length === 0">
            <div>
              <img src="assets/images/no-data.svg" height="100px" width="150px" alt="..."
                class="img-thumbnail border-0">
              <h6>{{noDataFoundLabel}}</h6>
            </div>
          </ng-container>

          <ng-container *ngIf="loading">
            {{loadingLabel}} ...
          </ng-container>
          <div class="entries" *ngIf="!loading">
            <ng-container *ngFor="let eventDetails of events;index as i">
              <div *ngIf="eventDetails.Show" class="entry project">

                <div class='dot hover-coursor' (click)=showViolationDetailsPopUp(i) [ngClass]="appConfig.ViolationNotificationTypes[eventDetails.ViolationName] != null 
    && appConfig.ViolationNotificationTypes[eventDetails.ViolationName].bgColorCss
     != null ? 
    appConfig.ViolationNotificationTypes[eventDetails.ViolationName].bgColorCss 
    : 'bg-dark-blue'">
                  <i class="voilation-icon text-secondary position-relative fa-light"
                    *ngIf="appConfig.ViolationNotificationTypes[eventDetails.ViolationName] != null"
                    [ngClass]="appConfig.ViolationNotificationTypes[eventDetails.ViolationName].icon_url">

                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill hover-coursor">
                      <i [ngClass]="(eventDetails.Category == null || eventDetails.Category === '') && appConfig.Escalate.Icons[eventDetails.StatusCode]"
                        aria-hidden="true" (mouseover)=setHoverId(eventDetails.ViolationId)
                        (mouseout)='unSetHoverId()'></i>

                      <div class="p-2 position-absolute shadow-b-light font-robort text-break hover-coursor"
                        style="top: 20px;z-index: 2;" *ngIf="hoverId == eventDetails.ViolationId">
                        <div class="text-success" *ngIf="eventDetails.StatusCode == 1">
                          APPROVED
                        </div>
                        <div class="text-danger" *ngIf="eventDetails.StatusCode == 2">
                          REJECTED
                        </div>
                        <div *ngIf="eventDetails.StatusCode == 0" class="text-dark ">
                          {{ eventDetails.SentDateTime | pendingTime }}
                        </div>
                      </div>
                    </span>
                  </i>
                  <i class="voilation-icon text-secondary position-relative fa-light fa-bell"
                    *ngIf="(eventDetails.Category == null || eventDetails.Category === '') && appConfig.ViolationNotificationTypes[eventDetails.ViolationName] == null">
                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill">
                      <i class="fa-light" [ngClass]="appConfig.Escalate.Icons[eventDetails.StatusCode]"
                        aria-hidden="true"></i>
                      <span class="visually-hidden">unread messages</span>
                    </span>
                  </i>
                </div>
                <div class='label'>

                  <div class='time'
                    *ngIf="eventDetails.ViolationDateTime && eventDetails.ViolationDateTime != 'Invalid Date'">
                    {{
                    eventDetails.ViolationDateTime | date : 'short'
                    }}
                  </div>

                  <div class='time'
                    *ngIf="eventDetails.ViolationDateTime && eventDetails.ViolationDateTime == 'Invalid Date'">
                    {{
                    eventDetails.ViolationUTCDateTime | date : 'short'
                    }}
                  </div>

                  <div class='detail'>
                    {{ appConfig.ViolationNotificationTypes[eventDetails.ViolationName] != null
                    && appConfig.ViolationNotificationTypes[eventDetails.ViolationName].label ?
                    appConfig.ViolationNotificationTypes[eventDetails.ViolationName].label
                    : eventDetails.ViolationName }}
                    <p class="card-text text-truncate font-sm m-0 font-primary-color lh-1"
                      (click)=copyText(eventDetails.BlackOutToken) *ngIf="eventDetails.BlackOutToken"
                      data-bs-toggle="tooltip" data-bs-placement="top"
                      title="{{blackOutTokenLabel}}: {{eventDetails.BlackOutToken}}">
                      {{blackOutTokenLabel}}: <span class="fw-bold hover-coursor">{{eventDetails.BlackOutToken}}</span>
                    </p>
                    <p *ngIf="eventDetails.EventId"
                      class="card-text text-truncate font-sm m-0 font-primary-color fw-bold">
                      {{eventIdLabel}}: {{eventDetails.EventId}}</p>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <ng-container *ngIf="!loadingEvents && eventHistoryLoadingComplete === false">
          <div *ngIf="!collapsed" class="w-100">
            <span (click)=loadNextViolationsRequest() class="font-xs d-flex float-start hover-coursor">
              <svg class="hand-pointer" xmlns="http://www.w3.org/2000/svg" data-bs-toggle="tooltip"
                data-bs-placement="top" title="{{loadPreviousViolationsLabel}}"
                xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                viewBox="0 0 232.395 232.395" style="enable-background:new 0 0 232.395 232.395;" xml:space="preserve">
                <path
                  d="M177.121,83.258c-5.921,0-11.324,2.26-15.393,5.962c-4.068-3.702-9.472-5.962-15.393-5.962  c-5.925,0-11.333,2.261-15.404,5.963c-1.672-1.522-3.579-2.783-5.645-3.76c7.467-9.163,11.828-20.792,11.828-33.095  C137.115,23.491,113.627,0,84.756,0C55.878,0,32.383,23.491,32.383,52.366c0,20.105,11.649,38.4,29.469,47.085v63.871  c0,38.086,30.988,69.072,69.077,69.072c38.092,0,69.083-30.986,69.083-69.072V106.15C200.012,93.527,189.743,83.258,177.121,83.258z   M47.383,52.366C47.383,31.762,64.148,15,84.756,15c20.6,0,37.359,16.762,37.359,37.366c0,11.702-5.529,22.549-14.467,29.515V52.366  c0-12.628-10.27-22.902-22.893-22.902c-12.629,0-22.904,10.274-22.904,22.902v29.513C52.912,74.915,47.383,64.068,47.383,52.366z   M185.012,163.322c0,29.815-24.262,54.072-54.083,54.072c-29.818,0-54.077-24.257-54.077-54.072V94.887  c0.013-0.251,0.013-0.502,0-0.751v-41.77c0-4.357,3.546-7.902,7.904-7.902c4.352,0,7.893,3.545,7.893,7.902v53.784v16.451  c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5V106.15c0-4.352,3.54-7.893,7.891-7.893c4.351,0,7.89,3.541,7.89,7.893v16.451  c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5V106.15c0-4.352,3.547-7.893,7.907-7.893c4.352,0,7.893,3.541,7.893,7.893  v16.451c0,4.142,3.358,7.5,7.5,7.5c4.142,0,7.5-3.358,7.5-7.5V106.15c0-4.352,3.541-7.893,7.893-7.893  c4.351,0,7.891,3.541,7.891,7.893V163.322z" />
              </svg>
            </span>
          </div>
        </ng-container>
      </div>
    </div>
  </div>

  <!-- CloseViolationsPopUpEvent: is a custom event which occurs when Popup is closed  -->
  <app-violation-approval (CloseViolationsPopUpEvent)="hideViolationDetailsPopUp()" [AgentProfilePic]="AgentProfilePic"
    [violationData]="events[violationIndexId]" [selectedAgentLanId]="AgentLanId" [enableEscalate]=enableEscalate
    *ngIf="showPopUp">
  </app-violation-approval>

  <secure-assist-details-popup (ClosePopUpEvent)="hideViolationDetailsPopUp()" *ngIf="showSecureAssistPopup"
    [eventDetails]="events[violationIndexId]" [eventDisplayName]="appConfig.ViolationNotificationTypes[events[violationIndexId].ViolationName] != null
      && appConfig.ViolationNotificationTypes[events[violationIndexId].ViolationName].label ?
      appConfig.ViolationNotificationTypes[events[violationIndexId].ViolationName].label
      : events[violationIndexId].ViolationName">
  </secure-assist-details-popup>

  <webrtc-screen-selection-popup (ClosePopUpEvent)="hideScreenSelectionPopup()" *ngIf="screenSelectionPopupVisibility"
    [screenDetails]="webrtcInfoService.getScreenShareDetails()" [AgentLanId]="screenshareAgentLanId">
  </webrtc-screen-selection-popup>

  <screen-glance-details-popup (ClosePopUpEvent)="hideScreenGlanceDetailsPopup()" *ngIf="screenGlancePopupVisibility"
    [eventDetails]="events[violationIndexId]">
  </screen-glance-details-popup>